import * as React from 'react';
import { callAll, noop } from '../../util/fn-util';
import { is } from '../../util/is';
import { getClassName } from '../../util/string-util';
import { FieldContextConsumer, IFieldContext } from './Field';
import './Select.scss';

class SelectContainer extends React.Component<IProps & { contextVal: IFieldContext }> {
  render() {
    const {
      className,
      onFocus,
      onBlur,
      onChange,
      onChangeValue,
      id,
      contextVal,
      children,
      ...props
    } = this.props;

    return (
      <select
        className={getClassName(
          'select',
          className,
          contextVal.isFilled && 'is-filled',
          contextVal.isFocused && 'is-focused'
        )}
        onFocus={callAll(onFocus, contextVal.handleSetIsFocused(true))}
        onBlur={callAll(onBlur, contextVal.handleSetIsFocused(false))}
        onChange={callAll(onChange, this.handleChange)}
        id={id || contextVal.fieldId}
        {...props}
      >
        {!props.required && <option value="" />}
        {children}
      </select>
    );
  }

  handleChange = (ev: React.ChangeEvent<HTMLSelectElement>) => {
    const value = ev.target.value;
    if (typeof this.props.onChangeValue === 'function') {
      this.props.onChangeValue(value);
    }

    this.props.contextVal.handleSetIsFilled(is.FilledText(value))();
  };

  componentDidMount() {
    if (is.Filled(this.props.value)) {
      this.props.contextVal.handleSetIsFilled(true)();
    }
  }

  static defaultProps: Partial<IProps> = {
    onChangeValue: noop
  };
}

interface IProps
  extends React.DetailedHTMLProps<
      React.SelectHTMLAttributes<HTMLSelectElement>,
      HTMLSelectElement
    > {
  onChangeValue?: (value: string) => void;
}

export const Select = ({ ref, ...props }: IProps) => (
  <FieldContextConsumer>
    {contextVal => <SelectContainer contextVal={contextVal} {...props} />}
  </FieldContextConsumer>
);



// WEBPACK FOOTER //
// ./src/components/Control/Select.tsx